import { IEntityType, ISignType } from '@patsnap/synapse_common_interface'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { sharedCtx } from '@pharmsnap/shared/src/context'
import { VUE_APP_MICRO_BASE_URL } from '../../../../apps/pharmsnap-web/src/config'
import { wujieCommonPlugins } from '../utils/wujie'

interface IMicroEntityCardWujiePropsOptions<T> {
  id: string
  type: IEntityType
  drug_id?: string
  data?: T
  direction?: 'vertical' | 'horizontal'
}

export function useMicroEntityCardWujieProps<T = any>(options: IMicroEntityCardWujiePropsOptions<T>) {
  const { locale } = useLocale()

  const microAppName = `micro-entity-card-${options.type}`
  const microEntityCardUrl = `${VUE_APP_MICRO_BASE_URL}/micro-entity-card/#/${options.type}`

  const getDataProps = () => {
    const { id: entityId, type: entityType, data: entityData } = options

    if (entityData) {
      return {
        id: entityId,
        getData: () => entityData,
      }
    }

    switch (entityType) {
      case 'drug':
        return {
          id: entityId,
          getData: (id: string) =>
            sharedCtx.service.drug.getCardInfo(id).then((res) => {
              return res.data
            }),
        }
      case 'target':
        return {
          id: entityId,
          getData: (id: string) =>
            sharedCtx.service.target.getCardInfo(id).then((res) => {
              return res.data
            }),
        }
      case 'organization':
        return {
          id: entityId,
          getData: (id: string) =>
            sharedCtx.service.organization.getCardInfo(id).then((res) => {
              return res.data
            }),
        }
      case 'disease':
        return {
          id: entityId,
          getData: (id: string) => {
            return sharedCtx.service.disease.getCardInfo(id, { drug_id: options.drug_id }).then((res) => {
              return res.data
            })
          },
        }

      default:
        console.error('未配置的实体卡片类型', entityType)
        return {
          id: '',
          getData: () => ({}),
        }
    }
  }

  const props = {
    ctx: {
      locale: locale.value,
    },
    direction: options.direction,
    ...getDataProps(),
    imgSignatureConfig: {
      batchGetImgSignatureData(params: { logoList: string[]; signType?: ISignType }) {
        return new Promise((resolve) => {
          sharedCtx.service.search
            .logoBatchSignatureWithCache(params)
            .then((res) => {
              resolve(res.data)
            })
            .catch(() => resolve({}))
        })
      },
    },
  }

  const attrs = {
    src: '/wujie/index.html',
  }

  return {
    props,
    microAppName,
    microEntityCardUrl,
    wujieCommonPlugins,
    attrs,
  }
}
